import React from "react";
import { Row, Col, Button } from "antd";
import "./index.css";
import { FaStripeS } from "react-icons/fa";
const ConnectToStripe = () => {
  return (
    <Row justify="center">
      <Col
        xs={24}
        sm={24}
        md={24}
        lg={24}
        xl={24}
        // style={{ border: "2px solid black" }}
        
      >
        <Row justify="space-between" style={{ marginTop: "20px" }}>
          <Col>
            <h3>Stripe Account Status</h3>
          </Col>
          <Col>
            <Button className="stipe-btn" icon={<FaStripeS size={15} />}>
              <span style={{ marginLeft: "10px", fontSize: 15  }}>
                Connect with Stripe
              </span>
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
export default ConnectToStripe;
